var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.ready
      ? _c("div", [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "quota" } }, [
                _vm._v("Maksymalna liczba zapytań")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.quota,
                    expression: "quota"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  id: "quota",
                  disabled: _vm.disableButton,
                  type: "number"
                },
                domProps: { value: _vm.quota },
                on: {
                  keyup: function($event) {
                    return _vm.isNumber()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.quota = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            !_vm.disableButton
              ? _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { disabled: _vm.disableButton },
                      on: { click: _vm.save }
                    },
                    [_vm._v("Zapisz")]
                  )
                ])
              : _c("div", [_vm.disableButton ? _c("RingLoader") : _vm._e()], 1)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "requests-count" } }, [
                _vm._v("Wykorzystana liczba zapytań")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.requestsCount,
                    expression: "requestsCount"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "requests-count", disabled: "" },
                domProps: { value: _vm.requestsCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.requestsCount = $event.target.value
                  }
                }
              })
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.ready ? _c("div", [_c("RingLoader")], 1) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-105aa0b6", { render: render, staticRenderFns: staticRenderFns })
  }
}